import "./MediaResources.scss";

import * as React from "react";
import { Header } from "../../components/Header";
import Footer from "../../components/Footer";
import {
  AnchorOutlineButton,
  OutlineButton,
} from "../../components/OutlineButton";
import CES2021 from "./img/ces2021_innovationawardsboi-png.png";
import CES2020 from "./img/ces2020-innovation-award-honoree-recipient.png";
import SUSTAINABILITY from "./img/SUSTAINABILITY-2020.png";
import MAGAZINE from "./img/JAN21-TheFurrow.png";
import classNames from "classnames";
import { ModalContext } from "../../components/modal/Modal";
import { PressReleases } from "./pages/PressReleases";
import { useParams } from "react-router-dom";

type VideoResourcesSection = "all" | "booth" | "tractor";

interface IVideoResourcesProps {
  section: VideoResourcesSection;
}

const urlRoot = "https://jd-ces-2022.s3.amazonaws.com/media-resources";

export const VideoResources: React.FunctionComponent<IVideoResourcesProps> = (
  props
) => {
  const [category, setCategory] = React.useState<"all" | "tractor" | "event">("all");
  const { handleModal } = React.useContext(ModalContext);

  const vidsAuto = [
    "VideoEight_WorkingInField",
    "VideoFive_Front",
    "VideoFour_DroneThree",
    "VideoOne_Cab",
    "VideoSeven",
    "VideoSix_Night",
    "VideoTwo_Drone",
  ];

  const vidsEvent = [
    "Feeding_the_World_John_Deere_Precision_Ag"
  ]

  const vidList = [];

  if (category === "all" || category === "tractor") vidList.push(...vidsAuto);
  if (category === "all" || category === "event") vidList.push(...vidsEvent);

  return (
    <div className="VideoResources">
      <div className="filters">
        <div
          onClick={() => setCategory("all")}
          className={classNames({ active: category === "all" })}
        >
          All
        </div>
        <div
          onClick={() => setCategory("tractor")}
          className={classNames({ active: category === "tractor" })}
        >
          Autonomous Tractor
        </div>
        <div
          onClick={() => setCategory("event")}
          className={classNames({ active: category === "event" })}
        >
          Event
        </div>
      </div>
      {vidList.length === 0 && <div className="no-images">Coming Soon.</div>}
      {vidList.map((x) => (
        <div
          className="img-wrapper"
          onClick={() =>
            handleModal({
              lightbox: true,
              video: `${urlRoot}/videos/${x.replaceAll(" ", "%20")}.mp4`,
            })
          }
        >
          <div
            className="img-thumb"
            style={{
              backgroundImage: `url(${urlRoot}/videos/thumb/${x.replaceAll(
                " ",
                "%20"
              )}.jpg)`,
            }}
          />
          <div className="thumb-overlay">
            <span>View</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export const BoothResources: React.FunctionComponent<IVideoResourcesProps> = (
  props
) => {
  const { handleModal } = React.useContext(ModalContext);

  const vidList: string[] = [
    "johndeere-ces2022-autonomy-farmer-demo-v2",
    "johndeere-ces2022-autonomy-tractor-demo-v2",
    "johndeere-ces2022-overview-v2",
    "johndeere-ces2022-data-demo",
    "johndeere-ces2022-farmer-demo",
    "johndeere-ces2022-see-spray-demo-v2",
    "johndeere-ces2022-harvest-demo-v3",
    "johndeere-ces2022-starfire-demo-v3",
    "deere-tireside-chat-1-driving-with-purpose",
    "deere-tireside-chat-2-old-macdonalds-farm",
    "deere-tireside-chat-3-swipe-to-begin-farming"
  ];

  return (
    <div className="VideoResources">
      {vidList.length === 0 && <div className="no-images">Coming Soon.</div>}
      {vidList.map((x) => (
        <div
          className="img-wrapper"
          onClick={() =>
            handleModal({
              lightbox: true,
              video: `${urlRoot}/videos/${x.replaceAll(" ", "%20")}.mp4`,
            })
          }
        >
          <div
            className="img-thumb"
            style={{
              backgroundImage: `url(${urlRoot}/videos/thumb/${x.replaceAll(
                " ",
                "%20"
              )}.jpg)`,
            }}
          />
          <div className="thumb-overlay">
            <span>View</span>
          </div>
        </div>
      ))}
    </div>
  );
};

interface IImageResourcesProps {}

type JdImageResource = string | { thumbnail: string; full: string };

export const ImageResources: React.FunctionComponent<IImageResourcesProps> = (
  props
) => {
  const [category, setCategory] = React.useState<
    "all" | "tractor" | "see-and-spray" | "presenters" | "event"
  >("all");
  const { handleModal } = React.useContext(ModalContext);

  const imgSeeAndSpray: string[] = ["r4f064314_VS.jpg", "r4f064278_rrd.jpg"];

  const imgTractor: JdImageResource[] = [
    "r4f167299_rrd_@1x.jpg",
    "r4f167301_rrd_@1x.jpg",
    "r4f167304_rrd_@1x.jpg",
    "r4f167312_rrd_@1x.jpg",
    "r4f167334_rrd_@1x.jpg",
    "r4f167365_rrd_@1x.jpg",
    "r4f167378_rrd_@1x.jpg",
    "r4f167384_rrd_@1x.jpg",
    "r4f167410_rrd_@1x.jpg",
    "r4f167426_rrd_@1x.jpg",
    "r4f167433_rrd_@1x.jpg",
    "r4f167436_rrd_@1x.jpg",
    "r4f167438_rrd_@1x.jpg",
    "r4f167445_rrd_@1x.jpg",
    "r4f167447_rrd_@1x.jpg",
    "r4f175043_rrd_@1x.jpg",
    "r4f175055_rrd_@1x.jpg",
    "r4f175064_rrd_@1x.jpg",
    { thumbnail: "mobile_thumbnail.jpg", full: "mobile_full.jpg" }
  ];

  const imgPresenters: string[] = [
    "hindman_jahmy_@2x.jpg",
    "kovar_deanna_@2x.jpg",
    "heraud_jorge_@2x.jpg",
    "ose_jenny_@2x.jpg",
    "sanchez_julian_@2x.jpg",
    "bansal_gaurav_@2x.jpg",
    "cafiero_igino_@2x.jpg",
    "donnellan_aubrey_@2x.jpg",
    "hall_marcus_@2x.jpg",
    "liefer_joseph_@2x.jpg",
    "neuendorf_melissa_@2x.jpg",
    "pell_willy_@2x.jpg",
    "savage_al_@2x.jpg",
    "showalter_brett_@2x.jpg",
    "nelson_taylor_@2x.jpg",
    "ebert_jon_@2x.jpg",
    "caes_laurel_@2x.jpg",
  ];

  const imgEvent: string[] = [];

  const imgList: { type: string; path: JdImageResource }[] = [];

  if (category === "all" || category === "tractor")
    imgList.push(...imgTractor.map((path) => ({ type: "tractor", path })));

  if (category === "all" || category === "see-and-spray")
    imgList.push(
      ...imgSeeAndSpray.map((path) => ({ type: "see-and-spray", path }))
    );

  if (category === "all" || category === "presenters")
    imgList.push(
      ...imgPresenters.map((path) => ({ type: "presenters", path }))
    );

  if (category === "all" || category === "event")
    imgList.push(...imgEvent.map((path) => ({ type: "event", path })));

  function labelFor(x: { type: string; path: JdImageResource }) {
    const path = typeof x.path === "string" ? x.path : x.path.full;
    if (x.type === "presenters")
      return path.replace("_@2x.jpg", "").replace(/(\w+)_(\w+)/g, "$2 $1");

    if (x.type === "event" && path.indexOf("_") > 2)
      return path.replace("_", " ").replace(".jpg", "");

    return "View";
  }

  return (
    <div className="ImageResources">
      <div className="filters">
        <div
          onClick={() => setCategory("all")}
          className={classNames({ active: category === "all" })}
        >
          All
        </div>
        <div
          onClick={() => setCategory("tractor")}
          className={classNames({ active: category === "tractor" })}
        >
          Autonomous Tractor
        </div>
        <div
          onClick={() => setCategory("see-and-spray")}
          className={classNames({ active: category === "see-and-spray" })}
        >
          See &amp; Spray™ Technology
        </div>
        <div
          onClick={() => setCategory("presenters")}
          className={classNames({ active: category === "presenters" })}
        >
          Experts
        </div>
        <div
          onClick={() => setCategory("event")}
          className={classNames({ active: category === "event" })}
        >
          Event
        </div>
      </div>
      <div className={classNames("images-grid", category)}>
        {imgList.length === 0 && <div className="no-images">Coming Soon.</div>}
        {imgList.map((x) => (
          <div
            className="img-wrapper"
            key={typeof x.path === "string" ? x.path : x.path.full}
            onClick={() =>
              handleModal({
                lightbox: true,
                img: `${urlRoot}/images/${typeof x.path === "string" ? x.path : x.path.full}`,
              })
            }
          >
            <div
              className={classNames("img-thumb", x.type)}
              style={{ backgroundImage: `url(${urlRoot}/images/${typeof x.path === "string" ? x.path : x.path.thumbnail})` }}
            />
            <div className="thumb-overlay">
              <span>{labelFor(x)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

interface IMediaResourcesFooterProps {}

export const MediaResourcesFooter: React.FunctionComponent<IMediaResourcesFooterProps> =
  (props) => {
    return (
      <div className="MediaResourcesFooter">
        <div className="Accolades">
          <h2>Accolades</h2>
          <div>
            <a
              href="https://www.ces.tech/Innovation-Awards/Honorees/2021/Best-Of/J/John-Deere-X-Series-Combine.aspx"
              target="_blank"
              rel="noreferrer"
            >
              <img src={CES2021} alt="" />
            </a>
            <h4>
              CES<sup>®</sup> INNOVATION AWARDS 2021 BEST OF INNOVATION
            </h4>
          </div>
          <div>
            <a
              href="https://www.ces.tech/Innovation-Awards/Honorees/2020/Honorees/J/John-Deere-8RX-Tractor.aspx"
              target="_blank"
              rel="noreferrer"
            >
              <img src={CES2020} alt="" />
            </a>
            <h4>
              CES<sup>®</sup> INNOVATION AWARDS 2020 HONOREE
            </h4>
          </div>
          <div>
            <a
              href="https://www.gadgetmatch.com/gadgetmatch-awards-best-of-ces-2020/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <img src={SUSTAINABILITY} alt="" />
            </a>
            <h4>SUSTAINABILITY AWARD 2020</h4>
          </div>
        </div>
        <div className="Magazine">
          <div>
            <h2>
              125 Years of <em>the Furrow</em>
            </h2>
            <p>
              <em>The Furrow</em> tells stories for and about the American
              farmer, with the January 2021 edition commemorating its 125th year
              of serving those who serve the land.
            </p>
            <AnchorOutlineButton
              text="View January 2021 Issue"
              to="https://www.deere.com/en/publications/the-furrow/"
            />
          </div>
          <div>
            <img src={MAGAZINE} alt="" />
          </div>
        </div>
        <div className="Contacts">
          <div>
            <h4>Jon Ebert</h4>
            <p>
              Manager, North American Public &amp; Industry Relations
              <br />
              John Deere Ag &amp; Turf Division
            </p>
            <p className="bold">
              Mobile: (913) 302-0592
              <br />
              EbertJonathanP@JohnDeere.com
            </p>
          </div>
          <div>
            <h4>Laurel Caes</h4>
            <p>
              Public Relations Manager – Technology &amp; Innovation
              <br />
              John Deere Ag &amp; Turf Division
            </p>
            <p className="bold">
              Mobile: (913) 749-9768
              <br />
              CaesLaurelJ@JohnDeere.com
            </p>
          </div>
          <div>
            <h4>Jennifer Grabowski</h4>
            <p>
              Vice President
              <br />
              Racepoint Global
            </p>
            <p className="bold">
              Mobile: (508) 631-6974
              <br />
              JohnDeereMedia@racepointglobal.com
            </p>
          </div>
        </div>
        <div className="Links">
          <AnchorOutlineButton
            text="Supplier Request Form"
            to="https://jdsn.deere.com/wps/portal/jdsn/Home/Welcome/!ut/p/z1/tZNNb8IgGMe_ih48GkD6xrF1ale1yzS-lItpKzqcUmxZ3fbpRzd3WVKXpRkHyBMefvlB_gAK1oCKuOT7WPFMxEddR9TaTEd3gxE2UOh4gQndIQpC_8FcWn0EloACmgol1ROIDttCbC4sKbhiHVhVX3NrzwTL42MrzYRiQnWgzLNCslTxkrWKFymPnOVFhZIp34III2LuEggNRmzLtBlBBBPkOEkSGxZjFlj95kX1NqwZLtTn6WdLLQFeG24wIu1gb0hvAqFv9EKIfQIfUTi4H8MZggsTrErOLmAhsvykn3L-h-v53_Qav-m4Cf2HuGN5phafzWfD4QR52G6MrrX-P3TfaIAObmcBVd-AH85n6uqsVxF-VWDdNOzydHLwW_d5Nx1gIwrKdy_sXhcaue32B0sna2s!/dz/d5/L2dBISEvZ0FBIS9nQSEh/"
            active={true}
          />
          <AnchorOutlineButton
            text="John Deere Newsroom"
            to="https://www.deere.com/en/our-company/news-and-announcements/newsroom/"
            active={true}
          />
        </div>
      </div>
    );
  };

interface IMediaResourcesProps {}

export const MediaResources: React.FunctionComponent<IMediaResourcesProps> = (
  props
) => {
  const { section } = useParams<{ section: "" | "booth" }>();
  const [tab, setTab] = React.useState<"images" | "video" | "pr" | "booth">(
    section === "booth" ? "booth" : "pr"
  );

  return (
    <div className="MediaResources">
      <Header />
      <div className="page-content">
        <h1>Resources</h1>
        <div className="tabs">
          <OutlineButton
            text="Press Releases"
            onClick={() => setTab("pr")}
            active={tab === "pr"}
          />
          <OutlineButton
            text="Images"
            onClick={() => setTab("images")}
            active={tab === "images"}
          />
          <OutlineButton
            text="Videos"
            onClick={() => setTab("video")}
            active={tab === "video"}
          />
          <OutlineButton
            text="Booth Demos"
            onClick={() => setTab("booth")}
            active={tab === "booth"}
          />
        </div>
        {tab === "images" && <ImageResources />}
        {tab === "video" && (
          <VideoResources section={section as VideoResourcesSection} />
        )}
        {tab === "booth" && (
          <BoothResources section={section as VideoResourcesSection} />
        )}
        {tab === "pr" && <PressReleases />}
      </div>
      <Footer />
    </div>
  );
};
